// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"9a69fca2","306":"55d7d55b","590":"d6c7524b","668":"18e58e97","722":"9265a6b5"}[chunkId] + ".chunk.js";
};